import React from "react";
import { ThemeProvider } from "styled-components";
import { Theme, themeTypes } from "../shared/styled/Theme";
import FeaturedMatchWrapper from "./components/FeaturedMatchWrapper/FeaturedMatchWrapper";

function FeaturedMatchMain({ options }) {
  return (
    <ThemeProvider
      theme={{ ...Theme, type: options?.theme || themeTypes.light }}
    >
      <FeaturedMatchWrapper options={options} />
    </ThemeProvider>
  );
}

// eslint-disable-next-line no-func-assign
FeaturedMatchMain = React.memo(FeaturedMatchMain);

export default FeaturedMatchMain;
